export const initialState = {};

export const TYPES = {
  ADD_BOOKMARK: "ADD_BOOKMARK",
  REMOVE_BOOKMARK: "REMOVE_BOOKMARK",
  RESET_BOOKMARK: "RESET_BOOKMARK",
};

const bookmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ADD_BOOKMARK: {
      const { id, name, bookmarkPath, bookmarkItem, menuIndex } = action.menu;
      const menu = state[id];

      // New menu item need to bookmark
      const newMenuBookmarkItem = {
        name: bookmarkItem.name,
        path: bookmarkPath,
        vintage: bookmarkItem?.vintage || "",
        format: bookmarkItem?.format || "",
        price: bookmarkItem?.price || "",
        menuIndex,
      };

      if (menu) {
        const updateMenu = {
          ...menu,
          bookmarks: [...menu.bookmarks, newMenuBookmarkItem],
        };

        return {
          ...state,
          [`${id}`]: updateMenu,
        };
      }

      return {
        ...state,
        [`${id}`]: {
          id,
          name,
          bookmarks: [newMenuBookmarkItem],
        },
      };
    }

    case TYPES.REMOVE_BOOKMARK: {
      const { menuId, bookmarkPath } = action.bookmark;
      const menu = state[menuId];

      if (menu) {
        const updateBookmarks = Object.assign([], menu.bookmarks).filter(
          (bookmark) =>
            bookmark.path.toLowerCase() !== bookmarkPath.toLowerCase()
        );

        const updateMenu = {
          ...menu,
          bookmarks: updateBookmarks,
        };

        return {
          ...state,
          [`${menuId}`]: updateMenu,
        };
      }

      return state;
    }

    case TYPES.RESET_BOOKMARK: {
      return initialState;
    }

    default:
      return state;
  }
};

export default bookmarkReducer;
